import { findLocationModalStyles } from "@WhiteCap/Overrides/Components/FindLocationModal";


// EC-94 : B2B Website Header
// Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments.
findLocationModalStyles.searchTextField = {
    labelProps: {
        weight: 600,
    },
};

findLocationModalStyles.searchRadiusText = {
    labelProps: {
        weight: 600,
    },
};
// End: Refactored dynamic CSS from CMS to code for consistent behavior across environments.